import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

export function RedirectComponent({to}:{to:string}){
    const nav=useNavigate()
    useEffect(()=>{
        nav(to);   
    })
    return <></>
}